import { portfolio } from "../data/portfolio";
import { SectionHead } from "../components/SectionHead";

function initials(org: string) {
  return org
    .split(/[·\s]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();
}

export function Experience() {
  return (
    <section id="experience" className="md-section">
      <div className="md-container">
        <SectionHead
          num="02"
          eyebrow="Experience"
          title="Where I've shipped."
          dek="Three internships across asset management, aerospace, and 3D ML — plus what came before."
        />

        <div className="m3-exp__grid">
          {portfolio.experience.map((e, i) => (
            <article key={i} className="md-card md-card--outlined md-card__pad reveal">
              <header className="m3-exp__head">
                <div className="m3-exp__logo">{initials(e.org)}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h3 className="md-title-l m3-exp__role">{e.role}</h3>
                  <div className="md-body-m m3-exp__org">{e.org}</div>
                </div>
                {e.href && (
                  <a
                    className="md-btn md-btn--icon"
                    href={e.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={`View certificate for ${e.role} at ${e.org}`}
                    title="View certificate"
                  >
                    <span className="material-symbols-rounded">open_in_new</span>
                  </a>
                )}
              </header>
              <div className="m3-exp__meta md-body-s">
                <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                  <span className="material-symbols-rounded icon-20">calendar_today</span>
                  {e.dates}
                </span>
                <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                  <span className="material-symbols-rounded icon-20">place</span>
                  {e.location}
                </span>
              </div>
              <ul className="m3-exp__bullets md-body-m">
                {e.bullets.map((b, j) => (
                  <li key={j}>
                    <span className="material-symbols-rounded">check</span>
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
              {e.tags && (
                <div className="m3-exp__tags">
                  {e.tags.map((t) => (
                    <span key={t} className="md-chip md-chip--assist">
                      {t}
                    </span>
                  ))}
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
